import { render, staticRenderFns } from "./No20.vue?vue&type=template&id=e8128c26&scoped=true"
import script from "./No20.vue?vue&type=script&lang=js"
export * from "./No20.vue?vue&type=script&lang=js"
import style0 from "./No20.vue?vue&type=style&index=0&id=e8128c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8128c26",
  null
  
)

export default component.exports